import {
  GET_OUTLETS_TERMINALS_FAILD,
  GET_OUTLETS_TERMINALS_LOADING,
  GET_OUTLETS_TERMINALS_SUCCESS,
} from "../types";

const initialState = {
  terminals: null,
  loading: null,
  error: null,
};

export const getOutletsTerminalsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; error: any }
) => {
  switch (action.type) {
    case GET_OUTLETS_TERMINALS_LOADING:
      return {
        ...state,
        loading: action.loading,
        error: null,
      };
    case GET_OUTLETS_TERMINALS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        terminals: action.payload,
      };
    case GET_OUTLETS_TERMINALS_FAILD:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
